import { createPortal } from 'react-dom';
import { m, AnimatePresence } from 'motion/react';
import { RefreshCw } from 'lucide-react';
import { useRegisterSW } from 'virtual:pwa-register/react';
import { Language } from '../types';
import { t } from '../utils/i18n';

/** Meldt dat er een nieuwe versie klaarstaat en laadt die na een tik. */
export default function UpdateToast({ language }: { language: Language }) {
  const {
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW({
    onRegisteredSW(_url, registration) {
      // Controleer elk uur op een nieuwe versie zolang de app open staat.
      if (registration) setInterval(() => registration.update().catch(() => {}), 60 * 60 * 1000);
    },
  });

  if (typeof document === 'undefined') return null;

  return createPortal(
    <AnimatePresence>
      {needRefresh && (
        <m.div
          role="status"
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 16 }}
          className="fixed bottom-6 left-1/2 -translate-x-1/2 z-[150] flex items-center gap-3 pl-4 pr-2 py-2 rounded-2xl bg-slate-900 dark:bg-slate-100 text-white dark:text-slate-900 shadow-2xl text-sm font-semibold"
        >
          <RefreshCw className="w-4 h-4 shrink-0" />
          <span className="whitespace-nowrap">{t(language, 'updateAvailable')}</span>
          <button
            onClick={() => updateServiceWorker(true)}
            className="min-h-11 px-4 rounded-xl bg-[#7C3AED] text-white whitespace-nowrap active:scale-95 transition-all duration-150 cursor-pointer"
          >
            {t(language, 'updateNow')}
          </button>
          <button
            onClick={() => setNeedRefresh(false)}
            className="min-h-11 px-3 rounded-xl text-white/70 dark:text-slate-600 whitespace-nowrap cursor-pointer"
          >
            {t(language, 'updateLater')}
          </button>
        </m.div>
      )}
    </AnimatePresence>,
    document.body,
  );
}
